<template>
    <div class="lesson-navigation">
        <LessonNavigationButton
            :class="['tw-px-6 tw-py-3 tw-mr-8 tw-rounded-lg tw-flex tw-items-center tw-justify-center tw-font-semibold tw-text-lg', buttonColor]"
            style="color: #676767;"
            direction="previous" :lesson="lesson" :module="module" :course="course">
            <i class="fa fa-angle-left tw-pr-2 tw-pt-px tw-mt-px"></i>
            <p style="margin-bottom: 0 !important;line-height:2;">{{ $t('navigation.previous') }}</p>
        </LessonNavigationButton>

        <LessonNavigationButton
            :class="['tw-px-6 tw-py-3 tw-rounded-lg tw-flex tw-items-center tw-justify-center tw-font-semibold tw-text-lg', buttonColor]"
            style="color: #676767;"
            direction="next" :lesson="lesson" :module="module" :course="course">
            <p style="margin-bottom: 0 !important;line-height:2;">{{ $t('navigation.next') }}</p>
            <i class="fa fa-angle-right tw-pl-2 tw-pt-px tw-mt-px"></i>
        </LessonNavigationButton>
    </div>
</template>

<script>
import LessonNavigationButton from "@/resources/assets/js/vue/components/e-learning/LessonNavigationButton.vue";

export default {
    name: 'LessonNavigation',

    components: {
        LessonNavigationButton
    },

    props: {
        course: {
            required: true,
        },
        module: {
            required: true,
        },
        lesson: {
            required: true,
        },
        buttonColor: {
            default: 'tw-bg-gray-200',
        }
    },
}
</script>

<style lang="scss" scoped>
.lesson-navigation {
    @media(max-width: 750px) {
        @apply tw-w-auto tw-mx-4 #{!important};
    }
}
</style>